export default String.raw`
{% if page.QueryString contains 'order-erp' -%}
	{% assign buttonClass = 'order-button-js' -%}
	{% assign inputClass = 'order-input-js' -%}
	{% assign urlType = 'order-erp=true' -%}
{% elseif page.QueryString contains 'invoice-erp' -%}
	{% assign buttonClass = 'invoice-button-js' -%}
	{% assign inputClass = 'invoice-input-js' -%}
	{% assign urlType = 'invoice-erp=true' -%}
{% elseif page.QueryString contains 'sor-erp' -%}
    {% assign buttonClass = 'sor-button-js' -%}
    {% assign inputClass = 'sor-input-js' -%}
    {% assign urlType = 'sor-erp=true' -%}
{% elseif page.QueryString contains 'wm-erp' -%}
    {% assign buttonClass = 'wm-button-js' -%}
    {% assign inputClass = 'wm-input-js' -%}
    {% assign urlType = 'wm-erp=true' -%}
{% elseif page.QueryString contains 'to-download-erp' -%}
    {% assign buttonClass = 'to-download-button-js' -%}
    {% assign inputClass = 'to-download-input-js' -%}
    {% assign urlType = 'to-download-erp=true' -%}
{% endif -%}

<div rv-if="FewPages" class="{% unless page.QueryString contains 'erp-data' -%} pagination-center {% endunless -%} pagination-right">
    <ul>
        <div class="pagination pager-js" data-template="partials/customer-profile/products-list.html">
            <button aria-label="{{ translations.Prev }}" type="button" disabled class="change-quantity-button prev-js container-reload-js {{buttonClass}}" data-url="{{page.Url}}?erp-data=true&{{urlType}}">
                <svg width="12" height="12" class="svgIcon" style="transform: rotate(180deg); margin-right: 12px"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use></svg><span>{{ translations.Prev }}</span>
            </button>
            <div class="page-amount current-page-js container-reload-js {{inputClass}}" data-url="{{page.Url}}?erp-data=true&{{urlType}}">{ PageNo }</div>
            <span class="page-amount">{{ translations.Of | Downcase }} <span class="page-count-js">{ PageCount }</span></span>
            <button aria-label="{{ translations.Next }}" type="button" class="change-quantity-button next-js container-reload-js {{buttonClass}}" data-url="{{page.Url}}?erp-data=true&{{urlType}}">
                <span>{{ translations.Next }}</span>
                <svg width="12" height="12" class="svgIcon" style="margin-left: 12px"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use></svg>
            </button>
        </div>
    </ul>
</div>
`